import React from "react";
import { deleteAllCookies } from "../../util";

const LkFooter = (props) => {
    const logout = () => {
        deleteAllCookies();
        window.location.replace("/");
    };
    return (
        <div className="flex flex-col gap-[10px] py-[15px]">
            <div>
                <a href="#" className="flex items-center gap-[14px]">
                    <div className=" rounded-[20px] inline-block"
                        style={{ background: props.data.MenuProfile.BtnInProfile.bgColor }}>
                        <img src={props.data.MenuProfile.profile.image} />
                    </div>
                    <div className={`transition-opacity duration-300`}>
                        {props.data.MenuProfile.BtnInProfile.text}
                    </div>
                </a>
            </div>
            <div onClick={logout} className="flex items-center gap-[14px]">
                <div className=" p-[6px] rounded-[20px] inline-block"
                    style={{ background: props.data.MenuProfile.BtnExit.bgColor }}>
                    <img src={props.data.MenuProfile.BtnExit.image} />
                </div>
                <div className={`transition-opacity duration-300`}>
                    {props.data.MenuProfile.BtnExit.text}
                </div>
            </div>
        </div>
    )
}

export default LkFooter;
